import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class VendorGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  private userIsVendor(): boolean {
    const raw = localStorage.getItem("permission");
    if (!raw) return false;
    try {
      const parsed = JSON.parse(raw);
      return !!parsed && !!parsed.is_vendor;
    } catch (_e) {
      return false;
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isVendor = this.userIsVendor();
    if (isVendor) {
      this.router.navigate(["access-denied/"]);
      return false;
    }
    return true;
  }
}
